import React, { Fragment, Component } from "react";
import { connect } from "react-redux";
import CustomSelector from "../../../common/customSelectorOptions";
import "./stepsTitle.styles.scss";

class StepTitle extends Component {
  state = {
    listOfID: [],
    listOfPortfolioNames: [],
    index: 0,
    selectedName: this.props.benchmark_name,
    data: {},
    displayOptions: false,
    list_of_name_id: [],
  };

  componentDidMount() {
    const { modelportfolios, activePortfolioID } = this.props;

    if (modelportfolios.length) {
      var listOfID = [],
        listOfPortfolioNames = [],
        list_of_name_id = [];

      var data = modelportfolios.map((e) => {
        let obj = {};
        listOfPortfolioNames.push(e["data"][0]["benchmark_name"]);
        listOfID.push(e["data"][0].scenario_id);

        obj[e["data"][0].scenario_id] = e["data"][0]["benchmark_name"];
        list_of_name_id.push(obj);
      });

      let obj = {};
      let index;

      if (listOfID.length) {
        for (let i = 0; i < modelportfolios.length; i++) {
          let x = {};

          x["name"] = modelportfolios[i]["name"];
          x["data"] = modelportfolios[i]["data"];

          obj[listOfID[i].toString()] = x;
        }

        if (activePortfolioID) {
          index = listOfID.indexOf(activePortfolioID.toString());
        }
      }
      this.setState({
        listOfID,
        listOfPortfolioNames,
        index,
        data: obj,
        list_of_name_id,
      });
    }
  }

  onChangeHandler = ({ name, id }) => {
    const { listOfPortfolioNames, listOfID, data } = this.state;
    const {
      setPortfolioID,
      setBenchmarkName,
      setActiveGoal,
      setBenchmarkLite,
    } = this.props;

    let index = listOfPortfolioNames.indexOf(name);
    let ids = listOfID[index];

    this.setState({
      selectedName: name,
      index,
    });

    let benchmark = this.state.data[ids.toString()]["data"][0]["benchmark"];

    setActiveGoal(data[`${id}`]);
    setPortfolioID(id);
    setBenchmarkName(name);
    setBenchmarkLite(benchmark);
  };
  render() {
    const { benchmark_name, portfolioActive, activePortfolioID } = this.props;
    const {
      listOfID,
      listOfPortfolioNames,
      index,
      list_of_name_id,
    } = this.state;

    let defaultValue = "";
    if (list_of_name_id.length) {
      let val = Object.values(
        list_of_name_id.filter((e) => Object.keys(e) == activePortfolioID)
      );

      defaultValue = val.length > 0 ? val[0][activePortfolioID] : "";
    }
    return (
      <Fragment>
        {benchmark_name && portfolioActive == true ? (
          <div className="create-steps">
            <Fragment>
              {/* ${benchmark_name} */}
              <label className="text-uppercase">{`Benchmark : `} &nbsp;</label>
              {/* {listOfPortfolioNames.length > 0 ? (
                <Fragment>
                  <select
                    className="create-steps__select"
                    value={this.state.selectedName}
                    onChange={(e) => this.onChangeHandler(e)}
                  >
                    {listOfPortfolioNames.map((name, i) => {
                      return (
                        <option
                          key={`${name}_${i}`}
                          value={name}
                          className="create-steps__select__option"
                        >
                          {name.length > 45
                            ? name.substring(0, 45) + "..."
                            : name}
                        </option>
                      );
                    })}
                  </select>
                  {/* <div
                  className="create-steps__btnHolder"
                  onClick={() =>
                    this.setState({
                      displayOptions: !this.state.displayOptions,
                    })
                  }
                  // onMouseOut={() => this.setState({ displayOptions: false })}
                >
                  <button className="create-steps__btnHolder__btn">
                    {" "}
                    {benchmark_name}{" "}
                  </button>

                  <div
                    className="create-steps__btnHolder__btn__listHolder"
                    onClick={() => this.setState({ displayOptions: false })}
                  >
                    {this.state.displayOptions == true ? (
                      <Fragment>
                        {listOfPortfolioNames.map((name, i) => {
                          return <div>{name}</div>;
                        })}
                      </Fragment>
                    ) : null}
                  </div>
                </div> 
                </Fragment>
              ) : null} */}
              {list_of_name_id.length && (
                <CustomSelector
                  textAlign="left"
                  defaultText={defaultValue}
                  optionsList={list_of_name_id}
                  changeHandler={(e) => this.onChangeHandler(e)}
                />
              )}
            </Fragment>
          </div>
        ) : null}

        {benchmark_name && portfolioActive == false ? (
          <div className="step__title">
            <h2 className="text-uppercase">Benchmark : {benchmark_name}</h2>
          </div>
        ) : null}
      </Fragment>
    );
  }
}

export default connect(
  ({
    create: {
      modelportfolios,
      steps: {
        risk: { benchmark_name, activePortfolioID },
        universeLite: { portfolioActive },
      },
    },
  }) => ({
    modelportfolios,
    benchmark_name,
    activePortfolioID,
    portfolioActive,
  }),
  (dispatch) => ({
    setPortfolioID: (payload) =>
      dispatch({ type: "SET_PORTFOLIO_ID", payload }),
    setBenchmarkName: (payload) =>
      dispatch({ type: "SET_BENCHMARKNAME", payload }),
    setActiveGoal: (inv) => dispatch({ type: "SET_ACTIVE_GOAL", payload: inv }),
    setBenchmarkLite: (val) =>
      dispatch({ type: "SET_BENCHMARK_LITE", payload: val }),
  })
)(StepTitle);



// WEBPACK FOOTER //
// ./src/components/pages/Create/universe_lite/StepTitle.jsx